import BSN from "bootstrap.native"
import Tabulator from "tabulator-tables";
import { ApplicationController } from "../application_controller";


Tabulator.prototype.extendModule("columnCalcs", "calculations", {
  "employeeBonusTotalsText": function (values, data, calcParams) {
    const table = document.getElementById("employee_bonuses_table")
    if (table)
      return table.getAttribute("data-total-text")
  },

  "employeeBonusTotalsBonusAmount": function (values, data, calcParams) {
    const table = document.getElementById("employee_bonuses_table")
    if (!table) return 0;
    let total_html = table.getAttribute("data-total");
    return total_html;
  },
});


export default class extends ApplicationController {
  static targets = ["index_table", "period_filter", "deal_filters", "partner_filters"]

  connect() {
    if (this.hasIndex_tableTarget) {
      const content_url = this.data.get("table-load-url");
      this.createTable(content_url);
    }
  }

  tableFilter() {
    this.setFilterToTable();
  }

  setFilterToTable() {
    let table = this.index_tableTarget.tabulator;
    let filters = []

    if (this.hasPeriod_filterTarget) {
      filters.push({
        field: "period",
        type: "=",
        value: this.period_filterTarget.value
      })
    }

    if (this.hasDeal_filtersTarget) {
      filters.push({
        field: "deals_ids",
        type: "=",
        value: this.deal_filtersTarget.choices.getValue(true)
      })
    }

    if (this.hasPartner_filtersTarget) {
      filters.push({
        field: "partners_ids",
        type: "=",
        value: this.partner_filtersTarget.choices.getValue(true)
      })
    }

    if (filters.length) {
      table.setFilter(filters);
    }
  }


  async createTable(url) {
    const columns = this.data.get("table-columns");
    const table_target = this.index_tableTarget;

    const default_props = super.tabulatorDefaultProps
    const height = document.getElementById('content').clientHeight;
    const sort_column = this.data.get("sort-column");
    const sort_dir = this.data.get("sort-dir");

    let table_props = {
      layout: "fitDataTable",
      virtualDomBuffer: 4000,
      index: "id",
      height: (height - 250) + "px",
      persistenceID: "employee_bonuses_table",
      movableColumns: true,
      // columns
      columns: JSON.parse(columns),
      // headerSort: false,
      // sort
      initialSort: [
        { column: sort_column, dir: sort_dir }
      ],
      paginationDataSent: {
        "size": "per_page"
      },
      paginationSize: 25,
      // Ajax
      ajaxURL: url,
      ajaxSorting: true,
      ajaxFiltering: true,
      ajaxProgressiveLoad: "scroll",
      ajaxLoader: true,
      ajaxLoaderLoading: "<div class='loader' > Loading...</div> ",
      //
      rowFormatter: function (row) {
        const data = row.getData();
        if (data.status_color) {
          row.getElement().className = row.getElement().className.replace(/(\s|^)row-\S+/g, '');
          row.getElement().classList.add("row-" + data.status_color);
        }
      },
      ajaxResponse:function(url, params, response){
        const table = document.getElementById("employee_bonuses_table")
        table.setAttribute("data-total", response.total);
        return response;
      }
    }

    table_props = Object.assign(default_props, table_props);
    // create table
    table_target.tabulator = new Tabulator(table_target, table_props);
    table_target.tabulator.setLocale(super.appLocale);
  }


}